<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
        lg="8"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="text-h3">
              原神用語辞書 Ver1.6
            </div>
          </template>
          <v-container class="pl-0 pr-0 pb-0">
            <!--辞書DL FAB-->
            <v-btn
              fixed
              fab
              top
              right
              color="primary"
              :disabled="downloading"
              :loading="downloading"
              @click="submit"
            >
              <v-icon color="white">mdi-download</v-icon>
            </v-btn>
            <!-- ローディングダイアログ -->
            <v-dialog
              v-model="error.dialog"
              hide-overlay
              persistent
              width="400"
            >
              <v-card
                color="primary"
                dark
              >
                <v-card-text>
                  辞書データをダウンロードしています
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  />
                </v-card-text>
              </v-card>
            </v-dialog>
            <!-- エラーダイアログ -->
            <v-dialog
              v-model="error.dialog"
              hide-overlay
              persistent
              width="400"
            >
              <v-card>
                <v-toolbar
                  color="error"
                  dark
                >
                  辞書データをダウンロードできませんでした
                </v-toolbar>
                <v-card-text>
                  {{ error.message }}
                </v-card-text>
                <v-divider />
                <v-card-actions>
                  <v-btn
                    color="primary"
                    text
                    @click="error.dialog = false; downloading = false"
                  >
                    閉じる
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- iPhoneダイアログ -->
            <v-dialog
              v-model="ime.dialog"
              width="500"
              persistent
              hide-overlay
            >
              <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                  <v-icon large>
                    mdi-information-outline
                  </v-icon>
                  iPhone, iPadについて
                </v-card-title>

                <v-card-text>
                  <p>Macの辞書をiCloud共有することによりiPhone, iPadでも辞書データを利用することができます。</p>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                  <v-btn
                    color="primary"
                    @click="selected_ime = ime.pc.mac.value; ime.dialog = false"
                  >
                    <v-icon class="mr-1">
                      {{ ime.pc.mac.icon }}
                    </v-icon>
                    {{ ime.pc.mac.label }}を選択する
                  </v-btn>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    text
                    @click="ime.dialog = false"
                  >
                    閉じる
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- インポートダイアログ -->
            <v-dialog
              v-model="howto.dialog"
              width="610"
            >
              <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                  {{ ime.names[selected_ime] }} インポート方法
                </v-card-title>

                <v-card-text class="justify-center">
                  <v-carousel
                    v-if="[ime.pc.pc_google.value, ime.pc.microsoft.value, ime.pc.atok.value].includes(selected_ime)"
                    progress-color="primary"
                  >
                    <v-carousel-item
                      v-for="(item, i) in howto[selected_ime]"
                      :key="i"
                      :src="getImg(item)"
                      reverse-transition="fade-transition"
                      transition="fade-transition"
                    />
                  </v-carousel>
                  <youtube-frame
                    v-else
                    :src="howto.movies[selected_ime]"
                  />
                  <!-- Mac iCloud共有方法 -->
                  <youtube-frame
                    v-if="selected_ime === ime.pc.mac.value"
                    :src="howto.movies.icloud"
                  />
                </v-card-text>

                <v-divider />

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    text
                    @click="howto.dialog = false"
                  >
                    閉じる
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-form
              ref="gdic_form"
            >
              <v-stepper
                v-model="stepper"
                class="elevation-0 pl-0 pr-0"
                vertical
                non-linear
              >
                <v-stepper-step
                  :complete="stepper > 1"
                  step="1"
                  editable
                  class="ml-0"
                >
                  お使いのIMEを選択してください。※必須
                  <v-chip
                    v-if="stepper != 1"
                    class="mt-2"
                  >
                    {{ ime.names[selected_ime] }}
                  </v-chip>
                </v-stepper-step>
                <v-stepper-content
                  step="1"
                >
                  <v-card
                    flat
                    class="ml-3 mr-3 mt-3"
                  >
                    <v-card-text>
                      <v-row justify="center">
                        <v-card
                          outlined
                          class="col-xl-4 col-lg-5 col-md-8 col-sm-12 mt-0 mr-2 pb-0"
                        >
                          <v-img
                            :src="require('@/assets/bg_pc.png')"
                            class="white--text align-end"
                            gradient="to bottom, rgba(220,220,220,0.4), rgba(100,100,100,0.6)"
                            max-height="200px"
                            max-width="300px"
                          >
                            <v-card-title>PC</v-card-title>
                          </v-img>
                          <v-card-text class="pl-0 pr-0 pb-0">
                            <v-list dense>
                              <v-list-item-group
                                v-model="selected_ime"
                                color="primary"
                              >
                                <v-list-item
                                  v-for="(item, key) in ime.pc"
                                  :key="key"
                                  :value="key"
                                >
                                  <v-list-item-icon>
                                    <v-icon v-text="item.icon">
                                      {{ item.icon }}
                                    </v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      {{ item.label }}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list-item-group>
                              <template
                                v-if="selected_ime == ime.pc.atok.value"
                              >
                                <v-chip
                                  outlined
                                  color="info"
                                  class="mt-1 mb-1"
                                >
                                  <v-icon class="mr-1">
                                    mdi-information-outline
                                  </v-icon>
                                  Atokについて
                                </v-chip>
                                <p class="text-body-1">
                                  Microsoft IME用の辞書データをインポートする形式での対応です。
                                </p>
                              </template>
                            </v-list>
                          </v-card-text>
                        </v-card>
                        <v-card
                          outlined
                          class="col-xl-4 col-lg-5 col-md-8 col-sm-12 mt-0 mr-2"
                        >
                          <v-img
                            :src="require('@/assets/bg_sm.png')"
                            class="white--text align-end"
                            gradient="to bottom, rgba(220,220,220,0.4), rgba(100,100,100,0.6)"
                            max-height="200px"
                            max-width="300px"
                          >
                            <v-card-title>スマホ</v-card-title>
                          </v-img>
                          <v-card-text class="pl-0 pr-0 pb-0">
                            <v-list dense>
                              <v-list-item-group
                                v-model="selected_ime"
                                color="primary"
                              >
                                <v-list-item
                                  v-for="(item, key) in ime.sm"
                                  :key="key"
                                  :value="key"
                                >
                                  <v-list-item-icon>
                                    <v-icon v-text="item.icon">
                                      {{ item.icon }}
                                    </v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title v-text="item.label">
                                      {{ item.label }}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                            <v-btn
                              rounded
                              elevation="1"
                              color="info"
                              :disabled="ime.dialog"
                              @click="ime.dialog = true"
                            >
                              <v-icon>mdi-information-outline</v-icon>iPhone, iPadについて
                            </v-btn>
                          </v-card-text>
                        </v-card>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-row>
                        <next-btn @click="stepper = 2" />
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>

                <!--DL辞書選択-->
                <v-stepper-step
                  step="2"
                  :complete="stepper > 2"
                  editable
                >
                  DLしたい辞書データを選んでください。
                  <v-chip
                    v-if="stepper != 2"
                    class="mt-2"
                  >
                    {{ dic[selected_dic].label }}
                  </v-chip>
                </v-stepper-step>
                <v-stepper-content step="2">
                  <v-card
                    flat
                    class="mt-0 pt-0"
                  >
                    <v-card-text>
                      <template v-if="selected_ime === ime.sm.gboard.value">
                        <p>Gboardは当サイトで生成した辞書データがインポートできなかったためカスタマイズ機能をご利用いただけません。</p>
                        <p>この辞書データは手動でGboard用に変換しているため最新ではありません。</p>
                      </template>
                      <p>2021/6/28 英語辞書は「日英キャラ名」としてPCのみ対応していましたが、「日英辞書」として週ボス、ボスの名前を追加しました。</p>
                      <v-list
                        dense
                        class="mt-0 pl-0 pr-0 pt-0 pb-0"
                      >
                        <v-list-item-group
                          v-model="selected_dic"
                          color="primary"
                        >
                          <v-list-item
                            v-for="(item, key) in dic"
                            :key="key"
                            :value="key"
                          >
                            <v-list-item-icon>
                              <v-icon v-text="item.icon">
                                {{ item.icon }}
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ item.label }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card-text>
                    <v-card-actions>
                      <v-row>
                        <back-btn @click="stepper -= 1" />
                        <next-btn
                          v-if="selected_ime !== ime.sm.gboard.value"
                          @click="stepper += 1"
                        />
                        <v-spacer />
                        <dl-btn
                          :downloading="downloading"
                          @click="submit"
                        />
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>

                <!-- 共通ステップ2以降 -->
                <template v-if="selected_ime !== 'gboard'">

                  <template v-if="selected_dic != dic.english.value">
                    <template v-if="selected_dic == dic.full.value">
                      <!--カテゴリ-->
                      <v-stepper-step
                        step="3"
                        :complete="stepper > 3"
                        editable
                      >
                        登録したい単語カテゴリにチェックを入れてください。
                        <template v-if="stepper != 3">
                          <v-chip
                            v-if="all_categories"
                            class="mt-2"
                          >
                            すべて登録する
                          </v-chip>
                          <v-chip
                            v-if="!all_categories && Array.isArray(categories_selected)"
                            class="mt-2"
                          >
                            {{ categories_selected.length }}のカテゴリが選択されています
                          </v-chip>
                        </template>
                      </v-stepper-step>
                      <v-stepper-content step="3">
                        <v-card
                          flat
                        >
                          <v-card-text>
                            <v-row
                              class="mb-0 mt-1"
                            >
                              <v-checkbox
                                key="allActivate"
                                v-model="all_categories"
                                input-value="true"
                                label="すべて登録"
                                class="col-auto mt-0 mr-1 mb-0 pt-1"
                              />
                              <v-btn
                                :disabled="all_categories"
                                color="primary"
                                small
                                elevation="0"
                                class="mr-1"
                                @click="categories_selected = []"
                              >
                                <v-icon>mdi-checkbox-blank-outline</v-icon>
                                すべてオフ
                              </v-btn>
                              <v-btn
                                color="primary"
                                small
                                elevation="0"
                                @click="categories.open = []"
                              >
                                <v-icon>mdi-close-box</v-icon>
                                ツリーを閉じる
                              </v-btn>
                            </v-row>
                            <v-radio-group
                              class="mt-0"
                              :disabled="all_categories"
                            >
                              <v-treeview
                                key="categories_treeview"
                                v-model="categories_selected"
                                :open="categories.open"
                                :items="categories.list"
                                @input="onInputCategory"
                                selection-type="leaf"
                                selected-color="primary"
                                expand-icon="mdi-chevron-down"
                                dense
                                selectable
                                open-on-click
                                return-object
                              >
                                <template v-slot:prepend="{ item }">
                                  <v-icon>
                                    {{ item.icon }}
                                  </v-icon>
                                </template>
                              </v-treeview>
                            </v-radio-group>
                          </v-card-text>
                          <v-card-actions>
                            <v-row>
                              <back-btn @click="stepper -= 1" />
                              <next-btn @click="stepper += 1" />
                            </v-row>
                          </v-card-actions>
                        </v-card>
                      </v-stepper-content>
                    </template>

                    <template v-if="selected_dic == dic.full.value">
                      <!--除外-->
                      <v-stepper-step
                        step="4"
                        :complete="stepper > 4"
                        editable
                      >
                        登録したくない単語を選択してください。
                        <v-chip-group v-if="stepper != 4">
                          <v-chip
                            v-for="(ex, key) in exclusion_selected"
                            :key="key"
                            class="mt-2"
                          >
                            {{ exclusion.data[ex].label }}
                          </v-chip>
                        </v-chip-group>
                      </v-stepper-step>
                      <v-stepper-content step="4">
                        <v-card
                          flat
                          class="mt-0"
                        >
                          <v-card-text>
                            <v-row class="mt-1 mb-2 ml-1">
                              <v-btn
                                color="primary"
                                normal
                                small
                                elevation="0"
                                class="mr-1"
                                @click="exclusion_selected = Object.keys(exclusion.data)"
                              >
                                <v-icon>mdi-checkbox-marked</v-icon>
                                すべてオン
                              </v-btn>
                              <v-btn
                                color="primary"
                                small
                                elevation="0"
                                @click="exclusion_selected = []"
                              >
                                <v-icon>mdi-checkbox-blank-outline</v-icon>
                                すべてオフ
                              </v-btn>
                            </v-row>
                            <v-chip-group
                              v-model="exclusion_selected"
                              class="mt-0"
                              column
                              multiple
                              active-class="primary--text"
                            >
                              <v-tooltip
                                v-for="(ex, key) in exclusion.data"
                                :key="key"
                                top
                                class="col-auto"
                                color="info"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-chip
                                    filter
                                    outlined
                                    :value="key"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    {{ ex.label }}
                                  </v-chip>
                                </template>
                                <span>{{ ex.chip }}</span>
                              </v-tooltip>
                            </v-chip-group>
                          </v-card-text>
                          <v-card-actions>
                            <v-row>
                              <back-btn @click="stepper -= 1" />
                              <next-btn @click="stepper += 1" />
                            </v-row>
                          </v-card-actions>
                        </v-card>
                      </v-stepper-content>
                    </template>

                    <!--リスト呼び出し文字-->
                    <v-stepper-step
                      :step="selected_dic == dic.selection.value ? 3 : 5"
                      :complete="stepper > (selected_dic == dic.selection.value ? 3 : 5)"
                      editable
                    >
                      リスト呼び出しに使う文字を入力してください。
                      <v-chip
                        v-if="stepper != (selected_dic == dic.selection.value ? 3 : 5)"
                        class="mt-2"
                      >
                        {{ list_char }}
                      </v-chip>
                    </v-stepper-step>
                    <v-stepper-content :step="selected_dic == dic.selection.value ? 3 : 5">
                      <v-card
                        flat
                      >
                        <v-card-text class="mt-2">
                          <p>
                            武器、聖遺物、地名、料理の一覧を出す際に使う文字を設定できます。記号など通常変換に使用しない文字を語頭に設定することで、意図しない変換を防ぎます。
                          </p>
                          <p v-if="selected_ime===ime.pc.mac.value">
                            初期値は「l」エルです。
                          </p>
                          <v-text-field
                            key="list_char"
                            v-model="list_char"
                            counter="4"
                            filled
                            dense
                            :hint="listChar.tip"
                            :rules="[listChar.limit_length]"
                          />
                          <p>変換例）</p>
                          <p>{{ list_char }}ゆみ→弓のリスト</p>
                          <p>{{ list_char }}せいいぶつ→聖遺物のリスト</p>
                        </v-card-text>
                        <v-card-actions>
                          <v-row>
                            <back-btn @click="stepper -= 1" />
                            <next-btn @click="stepper += 1" />
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>

                    <v-stepper-step
                      :step="selected_dic == dic.selection.value ? 4 : 6"
                      editable
                    >
                      単語の並び順を選んでください。
                      <v-chip
                        v-if="stepper != (selected_dic == dic.selection.value ? 4 : 6)"
                        class="mt-2"
                      >
                        {{ sortLabel[sort] }}
                      </v-chip>
                    </v-stepper-step>
                    <v-stepper-content :step="selected_dic == dic.selection.value ? 4 : 6">
                      <v-card
                        flat
                      >
                        <v-card-text>
                          <v-radio-group
                            v-model="sort"
                            row
                            class="mb-3 mt-0"
                          >
                            <v-radio
                              label="カテゴリ"
                              value="category"
                            />
                            <v-radio
                              label="よみ"
                              value="yomi"
                            />
                          </v-radio-group>
                        </v-card-text>
                        <v-card-actions>
                          <v-row>
                            <back-btn @click="stepper -= 1" />
                            <v-spacer />
                            <!-- DLボタン -->
                            <dl-btn
                              :downloading="downloading"
                              @click="submit"
                            />
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>
                  </template>

                </template>
                <!-- 共通ステップここまで -->
              </v-stepper>
            </v-form>
          </v-container>
        </base-material-card>
      </v-col>
    </v-row>
    <v-bottom-navigation
      class="elevation-0"
      dark
      background-color="primary"
      grow
    >
      <v-btn
        v-for="(item, key) in navigation"
        :key="key"
        :to="item.link"
        color="primary"
        dark
      >
        <span>{{ item.label }}</span>
        <v-icon>{{ item.icon }}</v-icon>
      </v-btn>
      <v-btn @click="howto.dialog = true">
        <span>インポート方法</span>
        <v-icon>mdi-file-document-outline</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import StructuredList from '@/views/dashboard/components/parts/StructuredList'
  import StepperNavi from '@/views/dashboard/components/parts/StepperNavi'
  import YoutubeFrame from '@/views/dashboard/components/parts/YoutubeFrame'
  import BackBtn from '@/views/dashboard/components/parts/BackBtn'
  import NextBtn from '@/views/dashboard/components/parts/NextBtn'
  import DlBtn from '@/views/dashboard/components/parts/DlBtn'
  export default {
    name: 'Dashboard',
    // eslint-disable-next-line vue/no-unused-components
    components: { YoutubeFrame, StructuredList, StepperNavi, BackBtn, NextBtn, DlBtn },
    data () {
      // localStorageに保存されてるフォーム情報をセット
      // 配列・ObjectはJSONで保存読み込みしないとだめよ
      const uri = 'http://anemoarchon.s205.xrea.com/api/gdic/'
      return {
        categoryFlag: false,
        stepper: 1,
        selected_ime: localStorage.ime ? localStorage.ime : 'pc_google',
        selected_dic: localStorage.dic ? localStorage.dic : 'full',
        all_categories: localStorage.all_categories === 'true',
        categories_selected: localStorage.category ? JSON.parse(localStorage.category) : [],
        exclusion_selected: localStorage.exclusion ? JSON.parse(localStorage.exclusion) : [],
        list_char: localStorage.list_char ? localStorage.list_char : '@',
        sort: localStorage.sort ? localStorage.sort : 'category',
        sortLabel: {
          category: 'カテゴリ',
          yomi: 'よみ',
        },
        navigation: {
          all: { label: '収録単語確認', icon: 'mdi-book', link: '/gdic/list' },
          history: { label: '更新履歴', icon: 'mdi-history', link: '/gdic/log' },
        },
        error: { dialog: false, message: '' },
        ime: {
          dialog: false,
          pc: {
            pc_google: { label: 'Google日本語入力', value: 'pc_google', icon: 'mdi-google' },
            microsoft: { label: 'Microsoft IME', value: 'microsoft', icon: 'mdi-microsoft-windows' },
            atok: { label: 'Atok※', value: 'atok', icon: 'mdi-microsoft-windows' },
            mac: { label: 'Mac 標準 IME', value: 'mac', icon: 'mdi-apple' },
          },
          sm: {
            android_google: { label: 'Google日本語入力', value: 'android_google', icon: 'mdi-google' },
            gboard: { label: 'Gboard※', value: 'gboard', icon: 'mdi-google' },
          },
          names: {
            pc_google: 'PC Google日本語入力',
            microsoft: 'PC Microsoft IME',
            atok: 'PC Atok',
            mac: 'PC Mac 標準 IME',
            android_google: 'Android Google日本語入力',
            gboard: 'Android Gboard',
          },
        },
        dic: {
          selection: { label: '厳選辞書', value: 'selection', icon: 'mdi-format-list-checks' },
          full: { label: '全部入り辞書', value: 'full', icon: 'mdi-book-alphabet' },
          english: { label: '日英辞書', value: 'english', icon: 'mdi-alpha-e-box-outline' },
        },
        listChar: {
          tip: '英数字、記号、ひらがなが使用できます。',
          limit_length: value => value.length <= 4 || '4文字以内で入力してください',
        },
        categories: {
          list: [],
          open: [],
          num: 0,
        },
        exclusion: {
          data: {
            npc: { label: 'NPC', chip: 'PCとPC化の可能性が高いキャラ（ダインスレイヴなど）のみ登録します', hover: false },
            misread: { label: '誤読での変換', chip: '弓蔵「ゆみかくし」和璞鳶「かはくえん」など', hover: false },
            enemy: { label: '「・」を含む長い正式名称', chip: 'アビスの魔術師・氷、エネルギー原盤・序論など', hover: false },
            weapon: { label: '☆3以下の武器', chip: '☆4,5のみ登録します', hover: false },
            artifact: { label: '☆4以下の聖遺物', chip: '☆5のみ登録します', hover: false },
            katakana: { label: 'カタカナのみの3文字以下の単語', chip: 'ジン、リサ、ガイアなど', hover: false },
            skill: { label: 'キャラ固有のスキル名', chip: '元素爆発名、元素スキル名、固有天賦名など', hover: false },
          },
        },
        howto: {
          dialog: false,
          movies: {
            android_google: 'https://www.youtube.com/embed/m5GqA8Z3mMs?start=14',
            gboard: 'https://www.youtube.com/embed/1_GFNs_Rk58?start=13',
            mac: 'https://www.youtube.com/embed/QQd3yndxKLU',
            icloud: 'https://www.youtube.com/embed/w68ybg8E298',
          },
          pc_google: [
            require('@/assets/gdic/google_import_001.png'),
            require('@/assets/gdic/google_import_002.png'),
            require('@/assets/gdic/google_import_003.png'),
          ],
          microsoft: [
            require('@/assets/gdic/microsoft_import_001.png'),
            require('@/assets/gdic/microsoft_import_002.png'),
          ],
          atok: [
            require('@/assets/gdic/atok_import_001.png'),
            require('@/assets/gdic/atok_import_002.png'),
            require('@/assets/gdic/atok_import_003.png'),
            require('@/assets/gdic/atok_import_004.png'),
          ],
        },
        en: false,
        downloading: false, // 辞書DL中かどうか
        api: uri,
      }
    },

    watch: {
      dialog (val) {
        if (!val) return

        setTimeout(() => (this.error.dialog = false), 5000)
      },
      // localStorageにフォームの内容を保存する
      selected_ime: function (newValue) {
        // IMEが変更された時に他の値を書き換える
        if (newValue === 'mac') {
          this.list_char = 'l'
          this.listChar.tip = '英数字またはひらがなを入力してください。記号は使用できません。'
        } else {
          // mac以外の時はデフォルト値に書き換えない
          this.listChar.tip = '記号、英数字、ひらがなが使用できます。'
        }
        localStorage.ime = this.selected_ime
      },
      selected_dic: function (newValue, old) {
        if (newValue) {
          localStorage.dic = this.selected_dic
        }
      },
      all_categories: function (newValue) {
        localStorage.all_categories = this.all_categories === true ? 'true' : 'false'
      },
      exclusion_selected: function (newValue) {
        localStorage.exclusion = JSON.stringify(this.exclusion_selected)
      },
      list_char: function (newValue) {
        localStorage.list_char = this.list_char
      },
      sort: function (newValue) {
        localStorage.sort = this.sort
      },
    },
    created: function () {
      const axios = require('axios').create({
        baseURL: this.api,
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'json',
      })
      // カテゴリ一覧をとってくる
      axios.get('category')
        .then(response => {
          this.categories.list = response.data.data
          if (this.categories_selected.length === 0) {
            this.categories_selected = response.data.ids
          } else {
            // このタイミングでlocalStorageから読み込まないと選択状態にならない
            this.categories_selected = JSON.parse(localStorage.category)
          }
          this.categoryFlag = true
        }).catch(error => {
          alert(error.message)
        })
    },
    mounted: function () {
    },
    updated: function () {
    },

    methods: {
      complete (index) {
        this.list[index] = !this.list[index]
      },
      onInputCategory: function (newVal, oldVal) {
        if (this.categoryFlag && newVal !== oldVal) {
          localStorage.category = JSON.stringify(newVal)
        }
      },
      showImportDialog () {
        // インポート方法を表示
        const dlFlagKey = 'downloaded_' + this.selected_ime
        if (localStorage.getItem(dlFlagKey) !== 'true') {
          this.howto.dialog = true
          localStorage.setItem(dlFlagKey, 'true')
        }
      },
      submit: function (dicName) {
        if (this.selected_ime === this.ime.sm.gboard.value) {
          // GboardはZIPを直接DL
          let url = this.api + 'dl/gboard/'
          if (this.selected_dic === 'selection') {
            url = this.api + 'dl/selection/' + this.selected_ime
          } else if (this.selected_dic === 'english') {
            url = this.api + 'dl/en/' + this.selected_ime
          }
          this.execApi(url).then(response => {
            this.dlFile(response)
            // インポート方法を表示
            this.showImportDialog()
          }).catch(error => {
            this.dialog = false
            this.error.message = error.toString()
            this.error.dialog = true
          })
          return
        }
        if (this.selected_dic === 'selection') {
          this.getSelectionDic()
          return
        } else if (this.selected_dic === 'english') {
          this.getEnglishDic()
          return
        }
        // 辞書生成リクエストを送る
        if (this.$refs.gdic_form.validate() !== true) {
          this.error.message = '入力内容を確認してください。'
          this.error.dialog = true
          return
        }
        this.downloading = true
        const params = []
        // カテゴリチェックボックス
        if (this.all_categories || this.categories.num === this.categories_selected.length) {
          // 全登録
          params.push('category=all')
        } else {
          const cat = []
          for (const key in this.categories_selected) {
            cat.push(this.categories_selected[key].id)
          }
          params.push('categories=' + cat.join(','))
        }
        // 除外設定
        if (this.exclusion_selected.length > 0) {
          params.push('exclusion=' + this.exclusion_selected.join(','))
        }
        // ソート
        params.push('sort=' + this.sort)
        // リスト呼び出し文字
        if (this.list_char !== '') {
          params.push('list=' + this.list_char)
        }
        // AtokはMicrosoftに置き換える
        const ime = this.selected_ime === this.ime.pc.atok.value ? this.ime.pc.microsoft.value : this.selected_ime
        const url = this.api + 'dl/' + ime + '?' + params.join('&')

        // 送信
        this.execApi(url).then(response => {
          this.dlFile(response)
          this.downloading = false
          // インポート方法を表示
          this.showImportDialog()
        }).catch(error => {
          this.downloading = false
          this.error.message = error.toString()
          this.error.dialog = true
        })
      },
      getEnglishDic () {
        // 日英辞書DL
        this.dialog = true
        // AtokはMicrosoftに置き換える
        const ime = this.selected_ime === this.ime.pc.atok.value ? this.ime.pc.microsoft.value : this.selected_ime
        const url = this.api + 'dl/en/' + ime
        this.execApi(url).then(response => {
          this.dlFile(response)
          // インポート方法を表示
          this.showImportDialog()
        }).catch(error => {
          this.dialog = false
          this.error.message = error.toString()
          this.error.dialog = true
        })
      },
      getSelectionDic () {
        const params = []
        // リスト呼び出し文字
        if (this.list_char !== '') {
          params.push('list=' + this.list_char)
        }
        // ソート
        params.push('sort=' + this.sort)
        // IME名処理AtokはMicrosoftIMEのデータをDL
        const ime = this.selected_ime === this.ime.pc.atok.value ? this.ime.pc.microsoft.value : this.selected_ime
        const url = this.api + 'dl/selection/' + ime + '?' + params.join('&')
        this.execApi(url).then(response => {
          this.dlFile(response)
          // インポート方法を表示
          this.showImportDialog()
        }).catch(error => {
          this.dialog = false
          this.error.message = error.toString()
          this.error.dialog = true
        })
      },
      dlFile (response) {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        const name = response.headers['content-disposition'].split('filename=')[1]
        link.href = url
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
        URL.revokeObjectURL(url)
        link.parentNode.removeChild(link)
      },
      execApi (url) {
        return axios({
          url: url,
          method: 'GET',
          responseType: 'arraybuffer',
          responseEncoding: 'binary',
          withCredentials: true,
          credentials: 'include',
        })
      },
      getImg (src) {
        return src
      },
    },
  }
</script>
<style>
.v-stepper__step {
  padding: 12px 12px 16px !important;
}
.v-stepper__content {
  margin: -8px -36px -16px 24px !important;
  padding: 16px 30px 16px 15px !important;
}
.v-list-item__icon {
  margin-right: 8px !important;
}
.v-list-item {
  padding: 0px 8px !important;
}
.v-card__text {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
.v-card__actions {
  padding-left: 12px !important;
}
.v-treeview-node__root {
  padding-left: 0px !important;
}
.v-treeview-node__checkbox {
  margin-left: 0px !important;
}
</style>
